import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';
import { InvoicesService } from '../../invoices.service';
import { InvoiceLinesDTO } from '@dto/invoices/invoice-lines-dto.model';
import { InvoiceModalEventData } from './invoice-modal-event-data';
import { LoadingAnimationComponent } from '@shared/components/loading-animation/loading-animation.component';
import { ModalWrapperComponent } from '@components/views/modal-wrapper/modal-wrapper.component';

@Component({
    selector: 'app-invoice-modal',
    templateUrl: './invoice-modal.component.html',
    styleUrls: ['./invoice-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoadingAnimationComponent, ModalWrapperComponent]
})
export class InvoiceModalComponent implements OnInit {
  private readonly invoicesService = inject(InvoicesService);

  readonly modalDataInput = input.required<InvoiceModalEventData>();

  readonly invoiceTotal = signal<string | undefined>(undefined);
  readonly invoiceCurrency = signal<string | undefined>(undefined);
  readonly invoiceNumber = signal<string | undefined>(undefined);
  readonly invoiceLines = signal<InvoiceLinesDTO[] | undefined>(undefined);

  readonly dataLoading = signal(true);
  readonly dataAvailable = signal(false);

  ngOnInit(): void {
    this.dataLoading.set(true);
    this.dataAvailable.set(false);

    const invoiceIdData = this.modalDataInput();
    this.invoicesService.getInvoiceLines(invoiceIdData.BillingNumber).pipe(
      catchError(error => {
        console.error('InvoiceModal: failed to load invoice lines', error);
        this.dataLoading.set(false);
        this.dataAvailable.set(false);
        return EMPTY;
      })
    ).subscribe(data => {
      if (data?.length > 0) {
        this.invoiceLines.set(data);
        this.invoiceTotal.set(data[0].Total);
        this.invoiceCurrency.set(data[0].Currency);
        this.invoiceNumber.set(invoiceIdData.InvoiceNumber);
      } else {
        this.invoiceLines.set(undefined);
        this.invoiceTotal.set(undefined);
        this.invoiceCurrency.set(undefined);
      }

      this.dataLoading.set(false);
      this.dataAvailable.set(Array.isArray(this.invoiceLines()) && this.invoiceLines()?.length > 0);
    });
  }
}
